/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import { baseCollectionBodySchema } from '../collection-body-schema';

export const createCollectionBodySchema = baseCollectionBodySchema;

export type ICreateCollectionBody = z.infer<typeof createCollectionBodySchema>;
